// extracted by mini-css-extract-plugin
export default {"wrapper":"profile-info_wrapper__EfMUQ","menu":"profile-info_menu__4GDyh","inputs":"profile-info_inputs__1gdBX","text":"profile-info_text__FEn2W","inner":"profile-info_inner__XpSKz"};